export { ZoomInAlt as default } from './ZoomInAlt';
